
export default function HowToApply() {
  const steps = [
    {
      number: '1',
      title: '公式サイトにアクセス',
      description: '下記のボタンから公式サイトへアクセスし、「スピード発番で申し込む」ボタンをクリックします。',
      icon: 'ri-cursor-line',
    },
    {
      number: '2',
      title: '必要情報を入力',
      description: '氏名、住所、電話番号、勤務先情報などの必要事項を入力します。所要時間は約5〜10分程度です。',
      icon: 'ri-edit-line',
    },
    {
      number: '3',
      title: '本人確認',
      description: '運転免許証やマイナンバーカードなどの本人確認書類をスマホで撮影してアップロード、または口座設定で本人確認を行います。',
      icon: 'ri-id-card-line',
    },
    {
      number: '4',
      title: '審査・カード番号発行',
      description: '最短5分で審査が完了し、カード会社公式アプリでカード番号が確認できます。すぐにネットショッピングやスマホ決済で利用可能です。',
      icon: 'ri-time-line',
    },
    {
      number: '5',
      title: '公式アプリをダウンロード',
      description: 'カード会社公式アプリをダウンロードしてログイン。カード番号や利用明細をいつでも確認できます。',
      icon: 'ri-smartphone-line',
    },
    {
      number: '6',
      title: 'プラスチックカードを受取',
      description: '約1週間後に自宅にプラスチックカードが届きます。届いたカードで店頭でのお買い物も可能になります。',
      icon: 'ri-mail-line',
    },
  ];

  const required = [
    '本人確認書類（運転免許証、マイナンバーカード、パスポートなど）',
    '銀行口座情報（引き落とし口座）',
    'メールアドレス',
    '電話番号',
    '勤務先情報（会社名、電話番号など）',
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#F8F9FA] to-[#E8F5E9]">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          地方銀行系スピード発行カードの申込み方法
        </h2>
        <p className="text-gray-600 text-center mb-12">最短5分で発行！簡単6ステップ</p>

        <div className="mb-12">
          <div className="relative">
            {steps.map((step, index) => (
              <div key={index} className="relative mb-8 last:mb-0">
                <div className="flex items-start gap-4">
                  <div className="relative flex-shrink-0">
                    <div className="w-16 h-16 flex items-center justify-center bg-[#00A651] rounded-full shadow-lg">
                      <i className={`${step.icon} text-white text-2xl`}></i>
                    </div>
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 -z-10 w-12 h-12 bg-[#00A651]/20 rounded-full"></div>
                    {index < steps.length - 1 && (
                      <div className="absolute top-16 left-1/2 -translate-x-1/2 w-0.5 h-16 bg-[#00A651]/30"></div>
                    )}
                  </div>
                  <div className="flex-1 bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="bg-[#003366] text-white text-xs font-bold px-3 py-1 rounded-full">
                        STEP {step.number}
                      </span>
                      <h3 className="text-lg font-bold text-[#003366]">{step.title}</h3>
                    </div>
                    <p className="text-gray-700 text-sm leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8">
          <h3 className="text-xl font-bold text-[#003366] mb-4 flex items-center gap-2">
            <i className="ri-file-list-line text-[#00A651] text-2xl"></i>
            申込みに必要なもの
          </h3>
          <ul className="space-y-3">
            {required.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-[#4CAF50] text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-gray-700 text-sm">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-[#E8F5E9] border-l-4 border-[#00A651] rounded-lg p-6">
          <h4 className="text-[#003366] font-bold text-base mb-2 flex items-center gap-2">
            <i className="ri-information-line text-[#00A651] text-xl"></i>
            スピード発番特典
          </h4>
          <p className="text-gray-700 text-sm leading-relaxed mb-3">
            スピード発番「スピ発」で申し込むと<strong className="text-[#00A651]">初年度年会費無料</strong>！
            さらに年間のご利用金額によっては翌年度以降も年会費が無料になります。
          </p>
          <p className="text-gray-600 text-xs">
            ※スピード発番の受付時間は9:00〜20:00です。時間外の申込は翌日以降の発行となる場合があります。
          </p>
        </div>
      </div>
    </section>
  );
}
